import React from 'react'
import '../../styles/_loader.scss'

const Loader = ({ className = '' }) => {
  return (
    <div className={`integrations-loader ${className}`}>
      <div className="align-middle-container">
        <div className="align-middle-content">
          <div className="integrations-loader-icon" />
        </div>
      </div>
    </div>
  ) 
}

export default Loader

